module.exports = __webpack_public_path__ + "img/mic3.55591e12.jpg";